import ajax from "./ajax";
const BASE = '/Home'
export const getViewData = (data)=>ajax(`${BASE}/TinyWebsite/index`,{...data})  //获取数据
